import { Component, Inject, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NativeService } from 'src/app/core/native/native.service';

@Component({
  selector: 'app-dialog',
  template: `
    <h1 class="dialog-title" mat-dialog-title *ngIf="data.title.length > 0">{{ data.title }}</h1>
    <mat-dialog-content>
        <div class="dialog-message" [innerHTML]="data.message"></div>
        <div id="dialog-input" *ngIf="data.showInput">
          <mat-form-field>
            <input type="text" matInput [formControl]="formControl" autocomplete="off">
            <mat-error *ngIf="formControl.hasError('required')">
              必須項目です。
            </mat-error>
            <mat-error *ngIf="formControl.hasError('maxLength')">
              36文字以下
            </mat-error>
          </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="dialog-actions" fxLayout="row" fxLayoutAlign="space-between stretch" fxFlexFill>
        <div [fxFlex] = "data.confirmText ? '50%' : '100%'" [ngClass]="data.confirmText ? 'right-border' : ''" 
          fxLayout="row" fxLayoutAlign="center center">
          <button mat-flat-button mat-dialog-close class="btn-close" tabindex="-1">{{ data.cancelText }}</button>
        </div>
        <div *ngIf="data.confirmText" [fxFlex] = "data.confirmText ? '50%' : '0%'" fxLayout="row" fxLayoutAlign="center center">
          <button mat-flat-button class="btn-confirm" color="accent" 
            (click)="confirm()" tabindex="1">{{ data.confirmText }}</button>
        </div>
      </div>
    </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.component.css'],

})
export class DialogComponent implements OnInit, AfterViewInit {
  
  formControl = new FormControl('', {
    validators: [Validators.required, Validators.maxLength(36)],
    updateOn: 'blur'
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      message: string,
      cancelText: string,
      confirmText?: string,
      showInput?: boolean,
    },
    private el: ElementRef,
    private nativeService: NativeService,
    private dialogRef: MatDialogRef<DialogComponent>
  ) {}

  ngOnInit(): void{
  }
  
  ngAfterViewInit(): void{
    if (this.data.showInput && !this.nativeService.isAndroid()) {
      this.el.nativeElement.parentNode.classList.add("add-bottom");
    }
  }

  confirm(): void{
    // Inputが表示された、かつ、未入力の場合
    if (this.data.showInput 
      && (this.formControl.value === null 
        || this.formControl.value.length === 0 
        || this.formControl.value.length > 36)) {
      return;
    }
    this.dialogRef.close(true);
  }

  getFlex(): string{
    return this.data.confirmText? '50%': '100%';
  }

}
